const configuredBaseUrl = import.meta.env.VITE_EKO_API_BASE_URL as string | undefined;

export const PORTAL_API_BASE_URL = (configuredBaseUrl || 'https://eko.elhamylabs.com').replace(/\/$/, '');

export const PORTAL_DEVICE_NUMBER = '1';

export const PORTAL_ROOT_PATH = '/account';

export const DOCTOR_ROOT_PATH = '/doctor';

export const PORTAL_LOGIN_PATH = '/login';

export const PORTAL_SESSION_MAX_AGE_MS = 12 * 60 * 60 * 1000;

export { LAB_WHATSAPP_NUMBER } from '@/data/contact';
